import { ButtonTertiary, desktopMestoBold, cssColorValue, spacer8, } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { hexToRgba } from '../../../utils/colorConversion';
import { useActiveSubmenu } from '../../ActiveSubmenu/ActiveSubmenuProvider';
const LabelButton = styled(ButtonTertiary) `
  cursor: pointer;
  ${desktopMestoBold};
  min-block-size: unset;
  padding: 0px;
  && {
    color: ${props => { var _a; return hexToRgba(((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'), 0.75); }};
    text-decoration: none;
    &:active,
    &:hover,
    &.active,
    &:focus {
      color: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      transform: none;
    }
    & > * {
      margin-inline-start: ${spacer8};
    }
  }
`;
export const SubmenuTrigger = ({ id, children, colors, }) => {
    const { claimActiveSubmenu, isActiveSubmenu } = useActiveSubmenu(id);
    return (React.createElement(LabelButton, { className: isActiveSubmenu ? 'active' : '', id: id, tabIndex: 0, onMouseEnter: claimActiveSubmenu, onKeyDown: (e) => {
            if (e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                claimActiveSubmenu();
            }
        }, colors: colors, condensed: true }, children));
};
//# sourceMappingURL=Trigger.js.map